import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import { Textarea } from "src/@/components/ui/textarea";
import useAuth from "src/hooks/useAuth";
import { AlertInfo } from "src/@/components/shared/AlertInfo";
// import v2_actionCreateNote from "src/actions/v2/chat/v2_actionCreateNote";

const ChatAddNoteComponent = ({ block, changeBlock }) => {
  const { t } = useTranslation('automation');

  return (
    <div className="w-full">
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium">{t('reactionCards.addNote.label', 'Nota')}</label>
          <Textarea
            value={block?.data?.chatNoteText}
            className="w-full"
            placeholder={t('reactionCards.addNote.placeholder', 'Escreva sua nota aqui...')}
            onChange={(e) => {
              let event = {
                name: "chatNoteText",
                value: e.target.value
              }
              changeBlock(event)
            }}
          />
        </div>
      </div>
      <div className="mt-8">
        <AlertInfo
          title={t('status.warning', { ns: 'common', defaultValue: 'Atenção' })}
          description={t('reactionCards.addNote.alertDescription', 'Se não houver nenhum chat vinculado, a nota não será adicionada.')}
        />
      </div>
    </div>
  );
};

export default ChatAddNoteComponent;
